import { flattenChildren } from '@/shared';
import { getPlanCuentaByEmpresa } from '@/shared/actions/erp';
import { TreeNode } from '@/shared/interfaces';
import { create } from 'zustand';


interface CatalogoPlanCuenta {
  catalogoPlanCuenta: TreeNode[];
  isLoadingCatalogoPlanCuenta: boolean;
  getCatalogoPlanCuenta: (empresa: string) => Promise<void>;
}

export const useCatalogoPlanCuentaStore = create<CatalogoPlanCuenta>(set => ({
  catalogoPlanCuenta: [],
  isLoadingCatalogoPlanCuenta: false,
  getCatalogoPlanCuenta: async params => {
    set({ isLoadingCatalogoPlanCuenta: true });
    const { cuentas } = await getPlanCuentaByEmpresa(params);
    set({ catalogoPlanCuenta: flattenChildren(cuentas || []) });
    set({ isLoadingCatalogoPlanCuenta: false });
  },
}));
